import { render, staticRenderFns } from "./Nestle.vue?vue&type=template&id=4b8e4fe0&scoped=true&"
import script from "./Nestle.vue?vue&type=script&lang=js&"
export * from "./Nestle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e4fe0",
  null
  
)

export default component.exports